import React from 'react';

const Button = ({
  onClick = () => { },
  outline = false,
  children = "Button",
  title = "",
  disabled = false,
  className = ''
}) => {
  return (
    <button
      className={`${outline ? 'tw-text-secondary tw-bg-transparent hover:tw-text-white' : 'tw-bg-secondary tw-text-white'} tw-text-sm hover:tw-bg-secondary tw-border-secondary tw-transition-all tw-border tw-font-bold tw-py-2 tw-px-4 tw-rounded-xl tw-border-solid tw-shadow-none tw-outline-none tw-ring-0 tw-flex tw-items-center tw-justify-center ${className}`}
      onClick={onClick}
      title={title}
      disabled={disabled}>
      {children}
    </button>
  );
}

export default Button;
